import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

export interface DropdownOption {
  value: number;
  label: string;
}

@Component({
    selector: 'app-dropdown-grid',
    templateUrl: './dropdown-grid.component.html',
    styleUrls: ['./dropdown-grid.component.scss'],
    standalone: false
})
export class DropdownGridComponent {
  @Input() options: DropdownOption[] = [];
  @Input() value: number = -1;
  @Input() placeholder: string = '';
  @Input() anyOptionLabel: string = 'Any';
  @Input() columns: number = 7;
  @Input() disabled: boolean = false;
  
  @Output() valueChange = new EventEmitter<number>();
  
  @ViewChild('container') container!: ElementRef;
  
  isVisible = false;
  dropdownTop = 0;
  dropdownLeft = 0;

  showPicker(event: FocusEvent) {
    const inputEl = event.target as HTMLElement;
    const rect = inputEl.getBoundingClientRect();
    
    this.dropdownTop = rect.bottom + 5;
    this.dropdownLeft = rect.left;
    
    const dropdownWidth = 280;
    if (this.dropdownLeft + dropdownWidth > window.innerWidth) {
      this.dropdownLeft = window.innerWidth - dropdownWidth - 10;
    }
    
    this.isVisible = true;
  }

  selectOption(value: number): void {
    this.value = value;
    this.valueChange.emit(value);
    this.isVisible = false;
  }

  getDisplayValue(): string {
    if (this.value === -1) return this.anyOptionLabel;
    const option = this.options.find(opt => opt.value === this.value);
    return option ? option.label : this.placeholder;
  }
}
